import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";

class SearchMenuHelper {
    public static Helper = new MyleHelper();

    public static BuildExpressionForNameSearch(str: string): string {
        var expression = str; var s = str.split(" "); if (s.length > 1) { expression = "(?=.*" + s[0] + ")(?=.*" + s[1] + ")"; } return expression;
    }

    public static FilterCliniciansByName(str: string, collection: Immutable.List<EmployeeUIModel>): Immutable.List<EmployeeUIModel> {
        var search = new RegExp(SearchMenuHelper.BuildExpressionForNameSearch(SearchMenuHelper.Helper.RemoveDiacritics(str)), "i");
        var filtered = collection.filter((item: EmployeeUIModel) => search.test(SearchMenuHelper.Helper.RemoveDiacritics(item.Name)));
        return filtered.toList();
    }

    public static FilterServicesByName(str: string, collection: Immutable.List<CheckboxUIModelT<ServiceModel>>): Immutable.List<CheckboxUIModelT<ServiceModel>> {
        var search = new RegExp(SearchMenuHelper.BuildExpressionForNameSearch(str), "i");
        var filtered = collection.filter((item: CheckboxUIModelT<ServiceModel>) => search.test(item.Name));

        return filtered.toList();
    }

    public static FilterCliniciansMembersOfSites(clinicians: Immutable.List<EmployeeUIModel>, siteIds: string[]): Immutable.List<EmployeeUIModel> {
        var filteredClinicians = clinicians.filter((c: EmployeeUIModel) => {
            var include = false;
            for (let siteId of c.Sites) {
                if (siteIds.indexOf(siteId) >= 0) {
                    include = true;
                    break;
                }
            }
            return include;
        });
        return filteredClinicians.toList();
    }

    public static GetCliniciansList(target: CheckboxTarget = CheckboxTarget.Myle_Documents_Clinicians): EmployeeUIModel[] {
        let list = cacheStore.EmployeeCacheWithInactive.map((e: Employee) => {
            var employee = EmployeeUIModel.fromCompositeObject(e);
            employee.Target = target;
            employee.Checked = false;
            employee.Visible = true;
            return employee;
        });
        return list;
    }
}

export { SearchMenuHelper };
